export default __webpack_public_path__ + "static/media/tela_erp.18581ef4.png";